(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["artista-collection-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('collection-description')) {
    class CollectionDescription extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('[data-collection-description-content]');
        this.toggle = this.querySelector('[data-collection-description-toggle]');
        this.moreLabel = this.querySelector('[data-label-more]');
        this.lessLabel = this.querySelector('[data-label-less]');

        if (!this.content || !this.toggle) return;

        this.handleToggle = () => this.setExpanded(this.dataset.expanded !== 'true');
        this.toggle.addEventListener('click', this.handleToggle);

        this.lastMeasuredWidth = -1;
        this.resizeObserver = new ResizeObserver(([entry]) => {
          const nextWidth = Math.round(entry.contentRect.width);
          if (nextWidth === this.lastMeasuredWidth) return;

          this.lastMeasuredWidth = nextWidth;
          this.measure();
        });
        this.resizeObserver.observe(this);

        requestAnimationFrame(() => this.measure());
        document.fonts?.ready.then(() => this.measure());
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.handleToggle);
        this.resizeObserver?.disconnect();
      }

      measure() {
        if (!this.content || !this.toggle) return;

        const wasExpanded = this.dataset.expanded === 'true';
        this.removeAttribute('data-collapsible');

        const styles = getComputedStyle(this.content);
        const lineHeight = Number.parseFloat(styles.lineHeight);
        const twoLineHeight = lineHeight * 2;
        const hasOverflow = this.content.scrollHeight > twoLineHeight + 2;

        if (hasOverflow) {
          this.setAttribute('data-collapsible', '');
          this.toggle.hidden = false;
          this.setExpanded(wasExpanded);
        } else {
          this.toggle.hidden = true;
          this.setExpanded(false);
        }
      }

      setExpanded(expanded) {
        const nextState = Boolean(expanded);
        this.dataset.expanded = String(nextState);
        this.toggle?.setAttribute('aria-expanded', String(nextState));

        if (this.moreLabel) this.moreLabel.hidden = nextState;
        if (this.lessLabel) this.lessLabel.hidden = !nextState;
      }
    }

    customElements.define('collection-description', CollectionDescription);
  }
  } catch(e) { console.error(e); }
})();

})();
